module.exports = __webpack_public_path__ + "img/repeat-02.c8a50407.svg";